<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{'Change email address' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="emailForm">
      <div class="form-group">
        <label>{{'New email address' | translate}}</label>
        <input type="email" class="form-control" formControlName="emailAddress" [class.is-invalid]="email?.invalid && email?.touched" />
        <div class="invalid-feedback" *ngIf="email?.errors?.['required']">
          {{'Email is required' | translate}}
        </div>
        <div class="invalid-feedback" *ngIf="email?.errors?.['email']">
          {{'Please enter a valid email address' | translate}}
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-between">
      <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close(false)">{{'Cancel' | translate}}</button>
      <button type="button" class="btn btn-primary" (click)="save()">
        <fa-icon [icon]="faSpinner" animation="spin" *ngIf="isProcessing"></fa-icon>
        {{'Save' | translate}}
      </button>
    </div>
  </div>
</div>
